import { EventHint, ErrorEvent } from '@sentry/react'

import { ApiError } from '@/lib/api'

export const beforeSendFilterResponses = (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {
  const error = hint.originalException;

  if (error && error instanceof ApiError && error.message.includes("Missing token")) {
    return null
  }

  return event
}